import { render, staticRenderFns } from "./emrNotes.vue?vue&type=template&id=fb059fcc"
import script from "./emrNotes.vue?vue&type=script&lang=js"
export * from "./emrNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports